import { businessAreas } from "@/mocks/homeData";

export default function BusinessSection() {
  return (
    <section id="business" className="relative w-full bg-navy-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="animate-on-scroll text-center mb-12 md:mb-16">
            <p className="text-sky-500 text-sm font-semibold tracking-wider uppercase mb-3">
              Business Areas
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-navy-900">
              핵심 사업영역
            </h2>
            <p className="text-navy-500 text-sm md:text-base mt-3 max-w-xl mx-auto">
              5가지 핵심 사업을 통해 글로벌 교육·문화·체육 교류를 선도합니다
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {businessAreas.map((area, index) => (
              <div
                key={area.id}
                className={`animate-on-scroll delay-${(index % 5) * 100 || 100} group bg-white rounded-xl p-5 md:p-6 border border-navy-100 hover:border-sky-200 hover:shadow-lg transition-all duration-300`}
              >
                <div className="w-12 h-12 bg-sky-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-sky-500 transition-colors">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${area.icon} text-sky-500 text-xl group-hover:text-white transition-colors`} />
                  </div>
                </div>

                <h3 className="text-base md:text-lg font-bold text-navy-900 mb-2">
                  {area.title}
                </h3>
                <p className="text-navy-500 text-sm leading-relaxed mb-4">
                  {area.description}
                </p>

                <ul className="space-y-1.5">
                  {area.items.map((item, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-navy-600">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-sky-400 text-xs" />
                      </div>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}